import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
import { BaseCta } from './BaseCta';

export class DisableCtaUnwrapped extends PureComponent {
  createTooltipProperties() {
    const { intl, tooltip } = this.props;

    if (!tooltip) {
      return null;
    }

    const tooltipMessage = typeof tooltip === 'object' ? intl.formatMessage(tooltip) : tooltip;

    return {
      'data-tooltip': tooltipMessage,
    };
  }

  render() {
    const { className } = this.props;
    const tooltipProperties = this.createTooltipProperties();

    return (
      <BaseCta
        className={classNames(className, 'bt--primary bt--disabled')}
        tooltipProps={tooltipProperties}
        onClick={() => {
          /* noop */
        }}
        disabled>
        <FormattedMessage id="schedule.cta.disabled" defaultMessage="Reserve" />
      </BaseCta>
    );
  }
}

DisableCtaUnwrapped.propTypes = {
  className: PropTypes.string,
  intl: intlShape.isRequired,
  tooltip: LocalizableMessageShape,
};

DisableCtaUnwrapped.defaultProps = {
  tooltip: null,
};

export const DisableCta = injectIntl(DisableCtaUnwrapped);
